import { ICellRendererParams } from "ag-grid-community";
import React from "react";

import { IgLink } from "@intelligems/ig-theme";
import { OrganizationSummarySubscriptionProductDto } from "@intelligems/ig-types";
import { openStripe } from "@src/features/admin/components/utils";

export const ViewColumn = (
  params: ICellRendererParams<OrganizationSummarySubscriptionProductDto>
) => {
  if (!params.data?.stripePriceId) {
    return null;
  }

  return (
    <IgLink
      onClick={() => {
        openStripe(`products/${params.data?.stripePriceId}`);
      }}
      color={"inherit"}
    >
      View
    </IgLink>
  );
};
